import { useWidgetConfigurationByOrganizationId } from './useWidgetConfigurationByOrganizationId';

export const useOrganizationHiddenFacts = () => {
  // TODO: MVP-5554 clean up logic (ref.: https://github.com/landler-io/landler/pull/4938#discussion_r2230252692)
  const organizationWidgetConfiguration = useWidgetConfigurationByOrganizationId().data;
  return organizationWidgetConfiguration ? organizationWidgetConfiguration.hidden_facts : [];
};
